var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 18.9492L10.8906 18.1328C11.1055 17.918 11.1055 17.5742 10.8906 17.4023L3.11328 9.625L10.8906 1.80469C11.1055 1.63281 11.1055 1.28906 10.8906 1.07422L10.0312 0.257812C9.85937 0.0429684 9.51562 0.0429684 9.30078 0.257812L0.320312 9.23828C0.105468 9.45312 0.105468 9.75391 0.320312 9.96875L9.30078 18.9492C9.51562 19.1641 9.85937 19.1641 10.0312 18.9492Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftThin);
export default __webpack_public_path__ + "static/media/arrow-left-thin.ad9a0137a0f212ae450699ee0ef133d8.svg";
export { ForwardRef as ReactComponent };